
const initialData = {
  layout: [],
  components: {
    component0: { id: "component0", type: "title" },
    component1: { id: "component1", type: "value" },
  }
};

export default initialData;
